// extracted by mini-css-extract-plugin
export default {"container":"ContentWithTextPlayer_container__zFJBB","htmlBox":"ContentWithTextPlayer_htmlBox__yC+39"};